'use client';
import React, { useState } from 'react';
import { Plus, Upload, Download, Check, X, Edit } from 'lucide-react';

export default function CountriesManagers() {
  const [countries, setCountries] = useState([
    {
      name: 'United States of America',
      billing: true,
      shipping: true,
      iso2: 'US',
      iso3: 'USA',
      numeric: 840,
      vat: false,
      states: 62,
      order: 1,
      published: true,
    },
    {
      name: 'Afghanistan',
      billing: true,
      shipping: true,
      iso2: 'AF',
      iso3: 'AFG',
      numeric: 4,
      vat: false,
      states: 0,
      order: 100,
      published: true,
    },
    {
      name: 'Albania',
      billing: true,
      shipping: true,
      iso2: 'AL',
      iso3: 'ALB',
      numeric: 8,
      vat: false,
      states: 0,
      order: 100,
      published: true,
    },
  ]);

  return (
    <div className="p-4 sm:p-8 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto bg-white shadow-md rounded-lg p-6">
        {/* Header */}
        <div className="flex flex-wrap justify-between items-center mb-4 gap-2">
          <h2 className="text-2xl font-semibold text-gray-800">Countries</h2>
          <div className="flex flex-wrap gap-2">
            <button className="bg-blue-600 text-white px-3 py-2 rounded flex items-center hover:bg-blue-700">
              <Plus className="w-4 h-4 mr-1" /> Add new
            </button>
            <button className="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700">
              Publish selected
            </button>
            <button className="bg-yellow-500 text-white px-3 py-2 rounded hover:bg-yellow-600">
              Unpublish selected
            </button>
            <button className="bg-emerald-600 text-white px-3 py-2 rounded flex items-center hover:bg-emerald-700">
              <Download className="w-4 h-4 mr-1" /> Export states to CSV
            </button>
            <button className="bg-gray-700 text-white px-3 py-2 rounded flex items-center hover:bg-gray-800">
              <Upload className="w-4 h-4 mr-1" /> Import states from CSV
            </button>
          </div>
        </div>

        <p className="text-sm text-gray-600 mb-4">
          Learn more about{' '}
          <a href="#" className="text-blue-600 underline">
            countries and states
          </a>
        </p>

        {/* Table */}
        <div className="overflow-x-auto border rounded-lg">
          <table className="min-w-full border-collapse text-sm text-gray-700">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border-b text-left">
                  <input type="checkbox" />
                </th>
                <th className="p-3 border-b text-left">Name</th>
                <th className="p-3 border-b text-left">Allows billing</th>
                <th className="p-3 border-b text-left">Allows shipping</th>
                <th className="p-3 border-b text-left">Two letter ISO code</th>
                <th className="p-3 border-b text-left">Three letter ISO code</th>
                <th className="p-3 border-b text-left">Numeric ISO code</th>
                <th className="p-3 border-b text-left">Subject to VAT</th>
                <th className="p-3 border-b text-left">Number of states</th>
                <th className="p-3 border-b text-left">Display order</th>
                <th className="p-3 border-b text-left">Published</th>
                <th className="p-3 border-b text-left">Edit</th>
              </tr>
            </thead>
            <tbody>
              {countries.map((c, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="p-3 border-b">
                    <input type="checkbox" />
                  </td>
                  <td className="p-3 border-b">{c.name}</td>
                  <td className="p-3 border-b text-center">
                    {c.billing ? (
                      <Check className="text-blue-600 w-4 h-4 inline" />
                    ) : (
                      <X className="text-red-500 w-4 h-4 inline" />
                    )}
                  </td>
                  <td className="p-3 border-b text-center">
                    {c.shipping ? (
                      <Check className="text-blue-600 w-4 h-4 inline" />
                    ) : (
                      <X className="text-red-500 w-4 h-4 inline" />
                    )}
                  </td>
                  <td className="p-3 border-b">{c.iso2}</td>
                  <td className="p-3 border-b">{c.iso3}</td>
                  <td className="p-3 border-b">{c.numeric}</td>
                  <td className="p-3 border-b text-center">
                    {c.vat ? (
                      <Check className="text-blue-600 w-4 h-4 inline" />
                    ) : (
                      <X className="text-red-500 w-4 h-4 inline" />
                    )}
                  </td>
                  <td className="p-3 border-b text-center">{c.states}</td>
                  <td className="p-3 border-b text-center">{c.order}</td>
                  <td className="p-3 border-b text-center">
                    {c.published ? (
                      <Check className="text-blue-600 w-4 h-4 inline" />
                    ) : (
                      <X className="text-red-500 w-4 h-4 inline" />
                    )}
                  </td>
                  <td className="p-3 border-b">
                    <button className="bg-gray-100 px-3 py-1 rounded hover:bg-gray-200 flex items-center">
                      <Edit className="w-4 h-4 mr-1" /> Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex flex-wrap justify-between items-center mt-4 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 border rounded bg-blue-50 text-blue-700">
              1
            </button>
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              2
            </button>
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              3
            </button>
            <button className="px-3 py-1 border rounded hover:bg-gray-100">
              Next
            </button>
          </div>

          <div className="flex items-center gap-2">
            <label>Show</label>
            <select className="border rounded px-2 py-1">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            <span>items</span>
          </div>
        </div>
      </div>
    </div>
  );
}
